export const pagination_style = {};
